import React from 'react';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message';
import { useIntl } from '@atlassian/jira-intl';
import type { FormattedMessageProps } from './types';
import { getTagFormatMessageValues } from './utils';

export const InterpolatedFormattedMessage = ({
	messageDescriptor,
	messageMappings,
	messageContexts,
}: FormattedMessageProps) => {
	const { formatMessage } = useIntl();
	const tags = Object.keys(messageMappings);
	const tagFormatMessageValues = getTagFormatMessageValues(tags);
	const formatMessageValues = { ...tagFormatMessageValues, ...messageContexts };

	return (
		<FormattedI18nMessage
			componentsMapping={messageMappings}
			message={formatMessage(messageDescriptor, formatMessageValues)}
		/>
	);
};
